import React, { useEffect, useState } from "react";
import { FaInstagram, FaTiktok, FaGlobe } from "react-icons/fa";
import { getAllboothsList, getCities, groupByCity } from "../../services/Booths";
import { useNavigate, useParams } from "react-router-dom";
import ls from "local-storage";
import { event } from "../../utils/gtag";
import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";

const socials = [
  {
    icon: <FaInstagram />,
    url: "https://instagram.com/sukhakala.id",
  },
  {
    icon: <FaTiktok />,
    url: "https://tiktok.com/@sukhakala.id",
  },
  {
    icon: <FaGlobe />,
    url: "https://sukhakala.id",
  },
];

export default function ByCitiesPage() {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const utmSource = params.get("utm_source");
  const { cityID } = useParams();

  // Parse slug and id from cityID param
  let citySlug = "";
  let cityId = "";
  if (cityID) {
    const match = cityID.match(/(.+)-(\d+)$/);
    if (match) {
      citySlug = match[1].replace(/-/g, " ").replace(/\b\w/g, (l) => l.toUpperCase());
      cityId = match[2];
    } else {
      cityId = cityID;
    }
  }

  useEffect(() => {
    console.log(cityID);
    if (utmSource && window.gtag) {
      window.gtag("set", "user_properties", {
        utm_source: utmSource,
      });
    }
  }, [utmSource]);
  const [boothsList, setboothsList] = useState([]);
  const [cityList, setCityList] = useState([]);
  function fetchboothsList(cityID) {
    groupByCity(cityID).then((response) => {
      setboothsList(response.data);
    });
  }
  function fetchLS() {
    if (ls.get("userDetail")) {
      const userDetail = ls.get("userDetail");
    }
  }
  useEffect(() => {
    fetchboothsList(cityId);
    fetchLS();
  }, [cityId]);

  // Collect booth names and notes for SEO
  const boothNames = boothsList
    .flatMap((cityGroup) => cityGroup.booths.map((booth) => booth.maps_name))
    .filter(Boolean);
  const boothNotes = boothsList
    .flatMap((cityGroup) => cityGroup.booths.map((booth) => booth.maps_notes))
    .filter(Boolean);

  return (
    <>
      <Helmet>
        <title>{`Sukhakala Photobooth di ${citySlug || "Kota"}`}</title>
        <meta
          name="description"
          content={`Daftar booth Sukhakala Photobooth di ${citySlug}. Booth: ${boothNames.join(
            ", "
          )}. Catatan: ${boothNotes.join("; ")}. Temukan lokasi photobooth, event, dan kolaborasi di kota ${citySlug}.`}
        />
        <meta
          name="keywords"
          content={`sukhakala photobooth, photobooth ${citySlug}, lokasi photobooth ${citySlug}, booth sukhakala ${citySlug}, event photobooth ${citySlug}, kolaborasi photobooth ${citySlug}, ${boothNames.join(
            ", "
          )}, ${boothNotes.join(", ")}`}
        />
      </Helmet>
      <div className="min-h-screen bg-gradient-to-b from-yellow-50 to-pink-50 flex flex-col items-center px-4 py-8">
        <img src="/latest-logo.jpg" alt="Sukhakala Logo" className="w-24 h-24 mb-4 rounded-full object-cover" />
        <h1 className="text-3xl font-bold text-center mb-2">Sukhakala Photobooth di {citySlug}</h1>
        <p className="text-center text-gray-700 mb-4" style={{ display: "none" }}>
          Temukan lokasi photobooth Sukhakala, event, dan kolaborasi di kota {citySlug}.
        </p>
        Keeping memories alive with the new ✨love language✨
        <br />
        <br />
        {/* Social Icons */}
        <div className="flex space-x-4 ">
          {socials.map((social, idx) => (
            <a
              key={idx}
              href={social.url}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() =>
                event({
                  action: "click_link",
                  category: "LinksPage",
                  label: social.url,
                })
              }
              className="text-2xl text-pink-600 hover:text-pink-800 transition"
            >
              {social.icon}
            </a>
          ))}
        </div>
        {/* Branch List */}
        <div className="w-full max-w-md space-y-2 text-center">
          {boothsList.length === 0 ? (
            <div className="text-gray-500">Loading branches...</div>
          ) : (
            boothsList.map((cityGroup, cityIdx) => (
              <div key={cityIdx} className="w-full max-w-md mb-6">
                <br />
                <h2 className="text-xl font-semibold mt-2 mb-4">📍 {cityGroup.cityName}</h2>
                <div className="flex flex-col gap-4">
                  {cityGroup.booths.map((booth, boothIdx) => (
                    <a
                      key={boothIdx}
                      href={booth.maps_url}
                      rel="noopener noreferrer"
                      className="bg-[#2b478e] text-white text-center py-3 px-6 rounded-xl shadow hover:bg-[#e7ac46] transition"
                      onClick={() =>
                        event({
                          action: "click_link",
                          category: "LinksPage",
                          label: booth.maps_name,
                        })
                      }
                    >
                      <span>📍 {booth.maps_name}</span>
                      {booth.maps_notes && (
                        <>
                          <hr className="w-full border-t border-white/30 my-1" />
                          <span className="italic text-sm">{booth.maps_notes}</span>
                        </>
                      )}
                    </a>
                  ))}
                </div>
              </div>
            ))
          )}
        </div>
        {/* Hidden SEO keywords for Indonesian search */}
        <div style={{ display: "none" }}>
          sukhakala photobooth, photobooth {citySlug}, lokasi photobooth {citySlug}, booth sukhakala {citySlug}, event
          photobooth {citySlug}, kolaborasi photobooth {citySlug},{boothNames.join(", ")}, {boothNotes.join(", ")}
        </div>
      </div>
    </>
  );
}
